import React from 'react'
import { pathOr } from 'ramda'

import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'
import LabelInput from '../../../../form/component/LabelInput'
import Select from '../../../../form/component/Select'
import ToggleButton from '../../../../form/component/ToggleButton'

const GroupData = ({ group, currentLanguage }) => {
    return (
        <Row top="M">
            <Column size={12}>
                <table className="customer-form-table">
                    <thead>
                        <tr>
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {group.answerList.map(answer => {
                            const question = answer.question[currentLanguage]
                            const answers = answer.answer.map(a => {
                                return a[currentLanguage] + ' '
                            })

                            return (
                                <tr key={answer.key}>
                                    <td className="key">{question}</td>
                                    <td className="value">{answers}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </Column>
        </Row>
    )
}

class AlignerTreatmentCustomerAssessment extends React.Component {
    constructor (props) {
        super(props)
        const availableLanguages = pathOr(
            [],
            ['anamnesis', 'availableLanguageList'],
            props
        )
        const defaultLanguage = availableLanguages.includes('de')
            ? 'de'
            : availableLanguages[0]

        this.state = {
            currentLanguage: defaultLanguage,
        }
        this.changeState = this.changeState.bind(this)
    }

    changeState (name, value) {
        this.setState({
            ...this.state,
            [name]: value,
        })
    }

    render () {
        const { anamnesis, showAnamnesis, toggleAnamnesis } = this.props

        const languageSelectorValueList = anamnesis.availableLanguageList.map(
            language => ({
                id: language,
                value: language,
            })
        )
        return (
            <div>
                <ToggleButton
                    toggle={toggleAnamnesis}
                    active={showAnamnesis}
                    activeIcon="fa fa-search-minus"
                    inactiveIcon="fa fa-search-plus"
                    className="anamnesis-toggle-button"
                />
                <Row top="M">
                    <Column size={6}>
                        <LabelInput label="Language">
                            <Select
                                object={this.state}
                                name="currentLanguage"
                                addEmpty={false}
                                onChange={this.changeState}
                                valueList={languageSelectorValueList}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={6}>
                        <LabelInput label="Selected language by patient">
                            <Select
                                object={this.state}
                                name="selectedUserLanguage"
                                addEmpty={false}
                                defaultValue={anamnesis.language}
                                readOnly={true}
                                valueList={languageSelectorValueList}
                            />
                        </LabelInput>
                    </Column>
                </Row>
                {showAnamnesis &&
                    anamnesis.formData.map(group => {
                        return (
                            <GroupData
                                key={group.groupId}
                                group={group}
                                currentLanguage={this.state.currentLanguage}
                            />
                        )
                    })}
            </div>
        )
    }
}

export default AlignerTreatmentCustomerAssessment



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/renderer/AlignerTreatmentCustomerAssessment.js